<template>
  <v-container fluid>
    <v-row
      v-if="esAdmin"
      class="mb-4"
    >

      <v-col cols="12" md="4">
        <v-select
          v-model="filtrosAdmin.proveedor"
          :items="listaProveedores"
          label="Proveedor"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filtrosAdmin.contratista"
          :items="listaContratistas"
          label="Contratista"
          clearable
          dense
          outlined
        />
      </v-col>

      <v-col cols="12" md="4">
        <v-select
          v-model="filtrosAdmin.estado"
          :items="listarEstados"
          label="Estado"
          clearable
          dense
          outlined
        />
      </v-col>
      <v-btn
        v-if="esAdmin"
        class="ma-2 white--text"
        color="light-blue darken-4"
        @click="descargarFacturacionValorizacion()"
      >
       <v-icon left>mdi-folder-multiple-plus-outline</v-icon
        >Exportar
      </v-btn>
    </v-row>
    <v-row>
      <!-- SOLO REQUERIMIENTOS CON EMPRESAS ADJUDICADAS -->
      <v-col
        v-for="req in requerimientosFiltrados"
        :key="req.idrequerimiento"
        cols="12"
      >
        <v-card outlined class="mb-6">
          <!-- HEADER -->
          <v-card-title class="blue-grey lighten-5">
            <div>
              <div class="req-title">
                <strong>{{ req.denominacion.slice(0, 3) }}</strong>
                <span class="grey--text"> - {{ req.empresa_contacto }}</span>
                <v-chip x-small class="ml-1">
                  {{ req.nombre_categoria }}
                </v-chip>
              </div>
              <div class="req-subtitle">
                <span class="grey--text">{{ detallesTextoServicio(req.detalles) }} ({{ detallesTexto(req.detalles) }})</span>
                <v-icon small class="ml-2">mdi-calendar</v-icon>
                {{ formatearFecha(req.fecha_inicio) }}
              </div>
            </div>
          </v-card-title>

          <v-card-text>
            <!-- EMPRESAS -->
            <div
              v-for="empresa in req.empresas"
              :key="empresa.id_empresa"
              class="mb-6"
            >
              <v-alert dense text color="#0095A9">
                Empresa adjudicada:
                <strong>{{ empresa.razonsocial }}</strong>
              </v-alert>
              <br>
              <!-- FACTURAS -->
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>N° Factura</th>
                    <th>Fecha Emisión</th>
                    <th>Fecha registro</th>
                    <th>Monto</th>
                    <th>Estado</th>
                    <th>Fecha Pago</th>
                    <th class="text-center">Acción</th>
                  </tr>
                </thead>

                <tbody>
                  <tr
                    v-for="factura in empresa.facturas"
                    :key="factura.id_facturacion"
                  >
                    <td>{{ factura.numero_factura }}</td>
                    <td>{{ formatFecha(factura.fecha_emision) }}</td>
                    <td>{{ formatFecha(factura.fecha_registro) }}</td>
                    <td>{{ factura.moneda === 'USD' ? '$' : 'S/' }} {{ factura.monto }}</td>

                    <td>
                      <span
                        class="badge"
                        :class="estadoClase(factura)"
                      >
                        {{ estadoTexto(factura) }}
                      </span>
                    </td>

                    <td>
                      {{ factura.fecha_pago
                        ? formatFecha(factura.fecha_pago)
                        : '-' }}
                    </td>

                    <td class="text-center">
                      <v-btn
                        v-if="factura.estado_pago !== 'PAGADO'"
                        small
                        class="btn-confirmar"
                        @click="abrirConfirmacion(factura)"
                      >
                        <v-icon small left>mdi-check-circle</v-icon>
                        Confirmar pago
                      </v-btn>
                    </td>
                  </tr>

                  <tr v-if="!empresa.facturas.length">
                    <td colspan="6" class="text-center grey--text">
                      No existen facturas registradas
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- VACÍO -->
      <v-col v-if="!requerimientosFiltrados.length" cols="12">
        <v-alert type="warning" text>
          No existen requerimientos con empresas adjudicadas
        </v-alert>
      </v-col>
    </v-row>

    <!-- DIALOGO CONFIRMAR -->
    <v-dialog v-model="dialogConfirmar" max-width="420">
      <v-card>
        <v-card-title class="headline">
          Confirmar pago
        </v-card-title>

        <v-card-text>
          ¿Confirmar el pago de la factura
          <strong>{{ facturaSeleccionada.numero_factura }}</strong>?

          <v-text-field
            v-model="fechaPago"
            label="Fecha de pago"
            type="date"
            outlined
            dense
          />
        </v-card-text>

        <v-card-actions class="justify-end">
          <v-btn text color="#9E9E9E" @click="dialogConfirmar = false">
            Cancelar
          </v-btn>

          <v-btn color="#0095A9" dark @click="confirmarPago">
            Sí, confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- SNACKBAR -->
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="3000"
      top
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from 'axios'

export default {
  name: 'FacturacionContratista',

  data () {
    return {
      requerimientos: [],
      dialogConfirmar: false,
      facturaSeleccionada: {},
      snackbar: {
        show: false,
        text: '',
        color: 'success'
      },
      filtrosAdmin: {
        proveedor: null,
        contratista: null,
        estado: null
      },
      fechaPago: new Date().toISOString().split('T')[0],
    }
  },

  created () {
    this.idcontratista = Number(localStorage.getItem('empresacontratista'))
    this.rol = localStorage.getItem('rol')
    this.idusuario = localStorage.getItem('idusuario')
    this.esAdmin =
    this.rol === 'ADMINISTRADOR'
    this.listarFacturacion()
  },

  computed: {
    listaProveedores () {
      return [...new Set(
        this.requerimientos.flatMap(r =>
          (r.empresas || []).map(e => e.razonsocial)
        )
      )]
    },

    listaContratistas () {
      return [...new Set(
        this.requerimientos.map(r => r.empresa_contacto)
      )]
    },

    listarEstados () {
      return [
        'PAGADO',
        'VENCIDO',
        'POR VENCER',
        'EN PLAZO',
        'SIN FACTURA'
      ]
    },

    requerimientosFiltrados () {
      return this.requerimientos
        .filter(r => {

          // filtro contratista
          if (
            this.filtrosAdmin.contratista &&
            r.empresa_contacto !== this.filtrosAdmin.contratista
          ) {
            return false
          }

          return true
        })
        .map(req => {

          const empresas = (req.empresas || [])
            .filter(emp => {

              // filtro proveedor
              if (
                this.filtrosAdmin.proveedor &&
                emp.razonsocial !== this.filtrosAdmin.proveedor
              ) {
                return false
              }

              // si NO hay filtro estado → mantener empresa
              if (!this.filtrosAdmin.estado) {
                return true
              }

              // si no tiene facturas
              if (!emp.facturas || !emp.facturas.length) {
                return this.filtrosAdmin.estado === 'SIN FACTURA'
              }

              // buscar alguna factura con ese estado
              return emp.facturas.some(f =>
                this.estadoTexto(f) === this.filtrosAdmin.estado
              )
            })

          return {
            ...req,
            empresas
          }
        })
        .filter(r => r.empresas.length > 0)
    }
    // requerimientosFiltrados () {
    //   return this.requerimientos.filter(
    //     r => r.empresas && r.empresas.length > 0
    //   )
    // }
  },

  methods: {
    listarFacturacion () {
      axios
        .get('api/PostulacionEmpresas/ListarPorContratistaPagos/' + encodeURIComponent(this.idusuario))
        .then(res => {
          this.requerimientos = res.data
        })
    },

    abrirConfirmacion (factura) {
      this.facturaSeleccionada = factura
      this.fechaPago = new Date().toISOString().split('T')[0]
      this.dialogConfirmar = true
    },

    async confirmarPago () {
      const f = this.facturaSeleccionada

      try {
        await axios.put('api/FacturacionRequerimientos/ActualizarPago', {
          id_facturacion: f.id_facturacion,
          fecha_pago: this.fechaPago
        })

        this.snackbar = {
          show: true,
          text: 'Pago confirmado correctamente',
          color: 'success'
        }

        this.dialogConfirmar = false
        this.listarFacturacion()
      }
      catch {
        this.snackbar = {
          show: true,
          text: 'Error al confirmar pago',
          color: 'error'
        }
      }
    },

    formatFecha (fecha) {
      return fecha ? new Date(fecha).toLocaleDateString() : ''
    },

    diasTranscurridos (fecha) {
      const hoy = new Date()
      const emision = new Date(fecha)
      return Math.floor((hoy - emision) / (1000 * 60 * 60 * 24))
    },

    estadoClase (f) {
      if (f.estado_pago === 'PAGADO') return 'badge-verde'
      const d = this.diasTranscurridos(f.fecha_emision)
      if (d >= 30) return 'badge-rojo'
      if (d >= 15) return 'badge-amarillo'
      return 'badge-verde'
    },

    estadoTexto (f) {
      if (f.estado_pago === 'PAGADO') return 'PAGADO'
      const d = this.diasTranscurridos(f.fecha_emision)
      if (d >= 30) return 'VENCIDO'
      if (d >= 15) return 'POR VENCER'
      return 'EN PLAZO'
    },
    detallesTexto(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.detalle).join(', ')
    },
    detallesTextoServicio(detalles) {
      if (!detalles || !detalles.length) return ''
      return detalles.map(d => d.servicio).join(', ')
    },
    formatearFecha(fecha){
      if(!fecha) return ''
      return new Date(fecha).toLocaleDateString()
    },
    async descargarFacturacionValorizacion() {

      this.downloadLoading = true
      try {
        const response = await axios.post(
          '/api/FiltrosContratos/ExportarFacturacion',
          null,
          { responseType: 'blob' }
        )
        const blob = new Blob([response.data])
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'archivo.xlsx'
        if (contentDisposition) {
          const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i)

          if (utf8Match) {
            fileName = decodeURIComponent(utf8Match[1])
          } else {
            const normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i)

            if (normalMatch) {
              fileName = normalMatch[1]
            }
          }
        }

        const urlBlob = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = urlBlob
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()

      } catch (error) {
        console.error('Error al exportar Excel', error)
      } finally {
        this.downloadLoading = false
      }
    },
  }
}
</script>

<style scoped>
.btn-confirmar {
  background: #0095A9;
  color: white;
}

.badge {
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
}

.badge-verde {
  background: #BABB13;
  color: #fff;
}

.badge-amarillo {
  background: #FDB714;
  color: #000;
}

.badge-rojo {
  background: #C05026;
  color: #fff;
}
.btn-confirmar {
  background-color: #16a34a !important; /* verde */
  color: #ffffff !important;
  font-weight: 600;
  text-transform: none;
}

.btn-confirmar:hover {
  background-color: #15803d !important;
}

.req-title {
  font-size: 18px;
  font-weight: 700;
}

.req-subtitle {
  font-size: 14px;
  color: #6b7280;
}

</style>
